import security from "./security"
import time from "./time"
import page from "./page"
import message from "./message"
import string from "./string"


export default {
    security:security,
    time:time,
    page:page,
    message:message,
    string:string
}


// WEBPACK FOOTER //
// ./src/util/index.js